// utils/formState.js
export function disableForm(form) {
    const buttons = form.querySelectorAll('button, input[type="submit"]');
    const inputs = form.querySelectorAll('input, textarea, select');
    buttons.forEach(btn => {
      btn.disabled = true;
      btn.classList.add('submitting');
    });
    inputs.forEach(input => input.disabled = true);
  
    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.dataset.originalText = submitButton.textContent;
      submitButton.textContent = 'Submitting...';
    }
  }
  
  export function enableForm(form) {
    const buttons = form.querySelectorAll('button, input[type="submit"]');
    const inputs = form.querySelectorAll('input, textarea, select');
    buttons.forEach(btn => {
      btn.disabled = false;
      btn.classList.remove('submitting');
    });
    inputs.forEach(input => input.disabled = false);
  
    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton && submitButton.dataset.originalText) {
      submitButton.textContent = submitButton.dataset.originalText;
      delete submitButton.dataset.originalText;
    }
  }